export default __webpack_public_path__ + "static/media/pt_not_same_articles.affdae70.png";